module.exports = __webpack_public_path__ + "img/Modernisme_Tanker_i_tida11.56c15a40.jpg";